import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreenCheckCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"data-testid": "green-check-circle",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .666748,
			width: 40,
			height: 40,
			rx: 20,
			fill: "#2AD062"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.3739 15.2929C27.7644 15.6834 27.7644 16.3166 27.3739 16.7071L19.3739 24.7071C18.9833 25.0976 18.3502 25.0976 17.9596 24.7071L13.9596 20.7071C13.5691 20.3166 13.5691 19.6834 13.9596 19.2929C14.3502 18.9024 14.9833 18.9024 15.3739 19.2929L18.6667 22.5858L25.9596 15.2929C26.3502 14.9024 26.9833 14.9024 27.3739 15.2929Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgGreenCheckCircle);
export { ForwardRef as ReactComponent };
